export const LocalStorageKeys = Object.freeze({
  JWT: 'token',
  USERNAME: 'username',
});

export const statusPlanet = Object.freeze({
  EMPIEZA: 'EMPIEZA AQUÍ',
  ACCEDER: 'ACCEDER',
  COMPLETADO: 'COMPLETADO',
  INCOMPLETO: 'INCOMPLETO',
});

export const LocalStoragePlanets = Object.freeze({
  PROJECTS: 'projects',
  MERCURIO: 'mercurio_data',
  VENUS: 'venus_data',
  MARTE: 'marte_data',
  SATURNO: 'saturno_data',
  URANO: 'urano_data',
  JUPITER: 'jupiter_data',
  LUNA: 'luna_data',
});

export const LocalStorageCompraTanques = Object.freeze({
  TANKS: 'tanks',
});

export const LocalStorageTanquesRestantes = Object.freeze({
  REMAINING_TANKS: 'remainingTanks',
});

